import { ref } from 'vue';

export function useJobFilters(router, store) {
  const filters = ref({ ...store.filters });

  const filterParamsMap = {
    search: 'search',
    location: 'location',
    education: 'education',
    experience: 'experience',
    jobType: 'job_type',
    gender: 'gender',
    ageRange: 'age_range',
  };

  const buildQueryFromFilters = (filterObj) => {
    const query = {};

    Object.entries(filterObj).forEach(([key, value]) => {
      if (value) {
        const queryKey = filterParamsMap[key] || key;
        query[queryKey] = value;
      }
    });

    return query;
  };

  const buildFiltersFromQuery = (query) => {
    const filterObj = {};

    Object.entries(filterParamsMap).forEach(([filterKey, queryKey]) => {
      filterObj[filterKey] = query[queryKey] || '';
    });

    return filterObj;
  };

  const updateUrl = (filterObj) => {
    const query = buildQueryFromFilters(filterObj);
    router.replace({ query });
  };

  const initFromUrl = (query) => {
    return buildFiltersFromQuery(query);
  };

  const syncFiltersToUrl = (filterObj) => {
    filters.value = { ...filterObj };
    updateUrl(filterObj);
  };

  const setFilters = (newFilters) => {
    const mergedFilters = { ...filters.value, ...newFilters };
    filters.value = mergedFilters;
    store.setFilters(newFilters);
    updateUrl(mergedFilters);
  };

  const clearSearch = () => {
    const clearedFilters = {
      search: '',
      location: '',
      education: '',
      experience: '',
      jobType: '',
      gender: '',
      ageRange: '',
    };

    filters.value = clearedFilters;
    store.setFilters(clearedFilters);

    router.replace({ query: {} });
  };

  return {
    filters,
    setFilters,
    clearSearch,
    updateUrl,
    initFromUrl,
    syncFiltersToUrl,
    buildQueryFromFilters,
    buildFiltersFromQuery,
  };
}
